/** @flow */
import { startRequest, finishRequest } from "@store/utils";
import {
  GetReportingFocusListsManagerDefaultReports,
  GetReportingFocusListsManagerDefaultReportsSuccess,
  GetReportingFocusListsManagerDefaultReportsError,
  GetReportingFocusListsManagerMyReports,
  GetReportingFocusListsManagerMyReportsSuccess,
  GetReportingFocusListsManagerMyReportsError,
  GetFocusListsManagerReportSchemaSuccess,
  GetFocusListsManagerReportSchemaError,
  SetFocusListsManagerReportToSave,
  ReSetFocusListsManagerReportToSave,
} from "@modules/reporting/constants/actions";
import type { Reports } from "./types";
import { cloneObject } from "@utils/object";

export const initialState = {
  requestsInProgress: 0,
  error: null,
  defaultReports: [],
  myReports: [],
  schema: null,
  reportToSave: null,
};

export const setLoading = (state: Reports) => () => startRequest(state);

export const onGetReportingFocusListsManagerDefaultReportsSuccess = (state: Reports) => ({
  payload,
}: Object) => ({
  ...finishRequest(state),
  error: null,
  defaultReports: payload,
});

const onGetReportingFocusListsManagerDefaultReportsError = (state: Reports) => ({
  payload,
}: Object) => ({
  ...finishRequest(state),
  error: payload.error,
});

export const onGetReportingFocusListsManagerMyReportsSuccess = (state: Reports) => ({
  payload,
}: Object) => ({
  ...finishRequest(state),
  error: null,
  myReports: payload,
});

const onGetReportingFocusListsManagerMyReportsError = (state: Reports) => ({
  payload,
}: Object) => ({
  ...finishRequest(state),
  error: payload.error,
});

export const onGetFocusListsManagerReportSchemaSuccess = (state: Reports) => ({
  payload,
}: Object) => ({
  ...state,
  error: null,
  schema: payload,
});

export const onGetFocusListsManagerReportSchemaError = (state: Reports) => ({
  payload,
}: Object) => ({
  ...state,
  error: payload.error,
});

export const onSetFocusListsManagerReportToSave = (state: Reports) => ({ payload }: Object) => ({
  ...state,
  reportToSave: payload,
});
export const onReSetFocusListsManagerReportToSave = (state: Reports) => ({ payload }: Object) => ({
  ...state,
  reportToSave: payload,
});

export default (state: Reports = initialState, action: Object): Reports => {
  const act = {
    [GetReportingFocusListsManagerDefaultReports]: setLoading,
    [GetReportingFocusListsManagerDefaultReportsSuccess]: onGetReportingFocusListsManagerDefaultReportsSuccess,
    [GetReportingFocusListsManagerDefaultReportsError]: onGetReportingFocusListsManagerDefaultReportsError,
    [GetReportingFocusListsManagerMyReports]: setLoading,
    [GetReportingFocusListsManagerMyReportsSuccess]: onGetReportingFocusListsManagerMyReportsSuccess,
    [GetReportingFocusListsManagerMyReportsError]: onGetReportingFocusListsManagerMyReportsError,
    [GetFocusListsManagerReportSchemaSuccess]: onGetFocusListsManagerReportSchemaSuccess,
    [GetFocusListsManagerReportSchemaError]: onGetFocusListsManagerReportSchemaError,
    [SetFocusListsManagerReportToSave]: onSetFocusListsManagerReportToSave,
    [ReSetFocusListsManagerReportToSave]: onReSetFocusListsManagerReportToSave,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
